import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'
import { IoIosArrowDown } from 'react-icons/io'
import styles from './styles.module.css'
import Button from '../../components/Button'
import Modal from './Modal'
import { Select } from '../../components/ModalInputs'
import { getStudyPlans, getSubjectsByYearStudy } from '../../actions/subjectsByYearStudy'

export default function SubjectsByYearStudy() {

  const dispatch = useDispatch()
  const { plans, subjects } = useSelector(state => state.subjectsByYearStudy)

  const [selectedPlan, setSelectedPlan] = useState(null)
  const [collapsed, setCollapsed] = useState({})
  const [modalLevel, setModalLevel] = useState(null)

  useEffect(() => {
    dispatch(getStudyPlans())
  }, [dispatch])

  useEffect(() => {
    if (!selectedPlan && plans?.length) {
      const defaultPlan = plans.find(p => p.is_default) || plans[0]
      setSelectedPlan(defaultPlan.trid)
    }
  }, [plans, selectedPlan])

  useEffect(() => {
    if (!selectedPlan) return
    dispatch(getSubjectsByYearStudy(selectedPlan))
    setCollapsed({})
    setModalLevel(null)
  }, [selectedPlan, dispatch])

  const toggleYear = (level) => setCollapsed(prev => ({ ...prev, [level]: !prev[level] }))

  const expandAll = (open) =>
    setCollapsed(open ? {} : Object.fromEntries((subjects || []).map(y => [y.level, true])))

  const closeModal = () => setModalLevel(null)

  const onSaved = (level) => {
    setCollapsed(prev => ({ ...prev, [level]: false }))
    closeModal()
  }

  const renderYear = ({ level, subjects: list }) => {
    const isCollapsed = !!collapsed[level]
    return (
      <div key={level} className={styles.year}>
        <div
          className={styles.yearHead}
          onClick={() => toggleYear(level)}
          onDoubleClick={() => setModalLevel(level)}
        >
          <IoIosArrowDown className={cn(styles.twisty, { [styles.twistyCollapsed]: isCollapsed })} />
          <span className={styles.yearTitle}>{level} год обучения</span>
          <span className={styles.yearCount}>{list.length ? `${list.length} предм.` : '—'}</span>
        </div>
        {!isCollapsed && (
          list.length
            ? list.map(s => (
              <div
                key={s.cid}
                className={styles.subject}
                onDoubleClick={() => setModalLevel(level)}
              >{s.title}</div>
            ))
            : <div className={styles.yearEmpty}>нет предметов</div>
        )}
      </div>
    )
  }

  return (
    <div className={styles.wrapper}>
      <h1>Распределение предметов по годам обучения</h1>

      <div className={styles.planRow}>
        <Select
          label='Учебный план'
          value={selectedPlan ?? ''}
          onChange={e => setSelectedPlan(Number(e.target.value))}
        >
          {plans?.map(({ trid, name }) => <option key={trid} value={trid}>{name}</option>)}
        </Select>
      </div>

      <div className={styles.treeCard}>
        <div className={styles.treeHead}>Годы обучения и предметы</div>
        <div className={styles.treeScroll}>
          {subjects
            ? subjects.length
              ? subjects.map(renderYear)
              : <div className={styles.yearEmpty}>нет данных</div>
            : <div className={styles.yearEmpty}>Загрузка...</div>}
        </div>
      </div>

      <div className={styles.toolbarRow}>
        <Button mode='white' className={styles.ghost} onClick={() => expandAll(true)}>Развернуть всё</Button>
        <Button mode='white' className={styles.ghost} onClick={() => expandAll(false)}>Свернуть всё</Button>
      </div>
      <div className={styles.hint}>
        Двойной клик по году обучения или предмету — редактировать состав предметов этого года.
      </div>

      {modalLevel !== null && !!selectedPlan &&
        <Modal
          trid={selectedPlan}
          level={modalLevel}
          closeModal={closeModal}
          onSaved={onSaved}
        />
      }
    </div>
  )
}
